<div id="rightSideBarContainer">
  <div id="rightSideBar" class="rightSidebar">
    <a class="menuCollapser" href="javascript:;">
      <span id="RightBarSelector" class="confirm_ico cart-solid" (click)="toggleClass('rgt_toggled')">@if (cartOrderList.length) {
        <i
        >{{cartOrderList.length}}</i>
      }</span>
      <h5 class="SummaryHeaderCls mb-0" id="prospectsidehead">Cart</h5>
    </a>
    <div class="cartItemContaner" [ngClass]="{'disableCart': disableCartStyle}">
      <div class="itemBody">
        @for (item of cartOrderList; track item) {
          <div class="cartItem mb-3 w-100 float-start">
            @if (item.CartItemType=== 1) {
              <div class="customer_cart_sec">
                <div class="confirmation_lst added_confirm_lst">
                  <a class="close_icon"
                  (click)="removeFromCart(item.CartItemType,item.UnitId, item.LeaseNo)">&nbsp;</a>
                  <div class="row no-gutters align-items-center">
                    <label class="col-4 m-0">Store Name</label>
                    <span class="col-7 ps-3">{{item.UnitDetails.Name}}</span>
                  </div>
                  <div class="row no-gutters align-items-center">
                    <label class="col-4 m-0">Unit #</label>
                    <span class="col-7 ps-3">{{item.UnitDetails.UnitNo}}</span>
                  </div>
                  <div class="row no-gutters align-items-center">
                    <label class="col-4 m-0">Move-In Date</label>
                    <span class="col-7 ps-3">{{item.UnitDetails.MoveInDate | date :'MM/dd/yyyy'}}</span>
                  </div>
                  <div class="row no-gutters align-items-center m-0">
                    <label class="col-4 m-0 NoSidePadding">Amount Due</label>
                    <span class="col-7 ps-3">{{item.totalCustomerDues | currency}}</span>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="cartFooter">
        @if (cartOrderList.length) {
          <div class="total_refund">
            <b>Total Amount: {{cartTotal | currency}}</b>
          </div>
        }
        @if (cartOrderList.length) {
          <div class="pay_butt_sec d-flex justify-content-end">
            <button type="button" class="btn btn-outline-primary me-3" (click)="onCancelCart()">Cancel</button>
            <button type="button" class="btn btn-primary" appDebounceClick
            (debounceClick)="openRentalPayment()">Process Payment</button>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div id="chartsContainer" class="mainContent">
  @if (paymentSection) {
    <app-payment [facilityId]="facilityIdPayment" [processPayment]="processPayData"
      [apiResponse]="responseFromApi" (emitLoopPayment)="loopPayment()" [receiptNumber]="receiptNumber"
      [Restrictiononcheckpayment]="Restrictiononcheckpayment" [autoPayInfo]="tenantAutoPayDetails"
      (isCancel)="paymentCancel($event)" (payCompleted)="postPayment($event)"
    (charityFeesContribution)="charityFeesContribution($event)"
    (surchargeContribution)="surchargeContributionReceived($event)" [displayCallScript]="false"></app-payment>
  }

  @if (DocumentViewPayment) {
    <app-document-shared [lettersList]="lettersListPayment"
      [defaultDocList]="defaultDocListPayment" [facilityId]="facilityIdPayment" [tenantId]="unitContactData.TenantId"
      [leaseNo]="leaseNoPayment" [transactionType]="transactionType" [unitNum]="UnitNoPayment"
      [NoentriesforLeaseAgreement]="NoentriesforLeaseAgreement" (emitgoToHostforEditInfoDoc)="goToHostforPayment($event)"
      (emitgoToHost)="goToHostPayment($event)" [displayCallScript]="false">
    </app-document-shared>
  }
</div>
<app-fingerprintpopup (cancelFingerPrint)="paymentCancel($event)" [paymentOrigin]="paymentOrigin"
(emitSuccess)="emitFingerPrintSuccess($event)"></app-fingerprintpopup>